import { PaymentComponent } from './payment.component';
import { PaymentService } from "./payment.service";
import { SharedModule } from "../shared/shared.module";
import { CommonModule } from "@angular/common";
import { Ng2PaginationModule } from "ng2-pagination";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CustomFormsModule } from "ng2-validation/dist";
import { BarChartComponent } from "../dashboard/chart/bar-chart.component";
import { PaymentModalComponent } from "./payment-modal.component";
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";

@NgModule({
    imports: [CommonModule, SharedModule, FormsModule, Ng2PaginationModule, ReactiveFormsModule, Ng2DatetimePickerModule, RouterModule],
    exports: [],
    declarations: [PaymentComponent, PaymentModalComponent],
    providers: [PaymentService],
})
export class PaymentModule { }



// WEBPACK FOOTER //
// ./src/app/payment/payment.module.ts